export { useToastTitleBase_unstable as useToastTitle } from '@fluentui/react-toast';
